import React from 'react';
import { Col } from 'react-bootstrap';
import QuestionGroup from "./QuestionGroup";
import { connect } from "react-redux";

class QuestionGroups extends React.Component {

	render() {

		let groups = this.props.groups.filter(group => group.section === this.props.section).map(function (group, index) {
			return (
				<QuestionGroup
					key={group.id}
					group={group}
					qsi={this.props.qsi}
					qgi={index+1}
					testObj={this.props.testObj}
				/>
			)
		}.bind(this));

		return (
			<div className="row questionnaire__sections__section__groups">
				<Col lg={12}>
					{groups}
				</Col>
			</div>
		)
	}
}

export default connect(state => ({ groups: state.formGroups}))(QuestionGroups);


// WEBPACK FOOTER //
// ./src/modules/form/view.1/QuestionGroups.js